import './careers.css';
import React from 'react';
import about from '../../images/careersPage/landing.png';
import aboutDesktop from '../../images/careersPage/careers-aboutautzu.png';
import AboutAutzuText from './AboutAutzuText';

const AboutAutzu = () => {
  return (
    <div className="aboutautzu-container container">
      <div className="aboutautzu-container__rectangular">
        <div className="innerbox">
          <div className="header">ABOUT AUTZU</div>
          <AboutAutzuText />
          <div className="jobButton">
            <button
              onClick={() =>
                window.open(
                  'https://www.linkedin.com/company/autzu/mycompany/'
                )
              }>
              Job openings
            </button>
          </div>
        </div>
      </div>
      <div className="mobileAboutImageContainer">
        <img className="mobileAboutImage" src={about} />
      </div>
      <img className="desktopAboutImage" src={aboutDesktop} />
    </div>
  );
};

export default AboutAutzu;



// WEBPACK FOOTER //
// ./src/components/Careers/AboutAutzu.js